<template>
  <v-card>
    <v-card-title class="bg-blue-grey-lighten-5 text-primary">
      送迎変更
    </v-card-title>

    <v-tabs
      v-model="tabs"
      fixed-tabs
      color="primary"
      slider-color="primary"
    >
      <v-tab value="dropOff">登園</v-tab>
      <v-tab value="pickup">降園</v-tab>
    </v-tabs>

    <v-card-text class="py-3">
      <v-window v-model="tabs" :transition="false" :reverse-transition="false">
        
        <v-window-item value="dropOff">
          <v-form ref="post_dropoff_form" class="pt-2">
            <v-dialog
              v-model="isDropOffDatePicker"
              width="auto"
              scroll-strategy="block"
            >
              <template v-slot:activator="{ props }">
                <div class="mt-4">
                  <div v-bind="props" class="ios-click-barrier">
                    <v-text-field
                      v-model="dropOffDate"
                      label="日付"
                      prepend-icon="mdi-calendar"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="compact"
                      readonly
                      inputmode="none"
                      tabindex="-1"
                      class="pointer-events-none"
                      color="primary"
                    ></v-text-field>
                  </div>
                </div>
              </template>
              <v-date-picker
                v-model="dropOffDateVal"
                locale="ja"
                :min="allowMinDate"
                title=""
                header=""
                elevation="12"
                class="rounded-lg"
                @update:model-value="onDropOffDateChange"
                color="primary"
              >
                <template v-slot:actions>
                  <v-spacer></v-spacer>
                  <v-btn variant="text" color="primary" @click="isDropOffDatePicker = false">OK</v-btn>
                </template>
              </v-date-picker>
            </v-dialog>

            <div class="mt-4">
              <div style="position: relative; z-index: 20;">
                <v-select
                  v-model="dropOffById"
                  :items="parentChoices"
                  item-title="value"
                  item-value="id"
                  :rules="[rules.required]"
                  label="登園の送迎者"
                  :loading="fetchLoading"
                  variant="outlined"
                  density="compact"
                  autocomplete="new-password"
                  name="dummy-dropoff"
                  color="primary"
                 :menu-props="{ offset: [0, 5] }"
                ></v-select>
              </div>
            </div>

            <div class="mt-4" style="position: relative; z-index: 10;">
              <time-picker
                v-model="dropOffTime"
                label="登園時間"
                prepend-icon="mdi-clock-time-four-outline"
                :rules="[rules.required]"
                variant="outlined"
                density="compact"
                color="primary"
              />
            </div>

            <div class="mt-4">
              <v-textarea
                v-model="dropOffReason"
                :rules="[rules.required, rules.counter100]"
                label="理由"
                auto-grow
                max-rows="7"
                variant="outlined"
                density="compact"
                color="primary"
              />
            </div>
          </v-form>
        </v-window-item>

        <v-window-item value="pickup">
          <v-form ref="post_pickup_form" class="pt-2">
            
            <v-dialog
              v-model="isPickupDatePicker"
              width="auto"
              scroll-strategy="block"
            >
              <template v-slot:activator="{ props }">
                <div class="mt-4">
                  <div v-bind="props" class="ios-click-barrier">
                    <v-text-field
                      v-model="pickupDate"
                      label="日付"
                      prepend-icon="mdi-calendar"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="compact"
                      readonly
                      inputmode="none"
                      tabindex="-1"
                      class="pointer-events-none"
                      color="primary"
                    ></v-text-field>
                  </div>
                </div>
              </template>
              <v-date-picker
                v-model="pickupDateVal"
                locale="ja"
                :min="allowMinDate"
                title=""
                header=""
                elevation="12"
                class="rounded-lg"
                @update:model-value="onPickupDateChange"
                color="primary"
              >
                <template v-slot:actions>
                  <v-spacer></v-spacer>
                  <v-btn variant="text" color="primary" @click="isPickupDatePicker = false">OK</v-btn>
                </template>
              </v-date-picker>
            </v-dialog>

            <div class="mt-4">
              <div style="position: relative; z-index: 20;">
                <v-select
                  v-model="pickupById"
                  :items="parentChoices"
                  item-title="value"
                  item-value="id"
                  :rules="[rules.required]"
                  label="降園の送迎者"
                  :loading="fetchLoading"
                  variant="outlined"
                  density="compact"
                  autocomplete="new-password"
                  name="dummy-pickup"
                  color="primary"
                 :menu-props="{ offset: [0, 5] }"
                ></v-select>
              </div>
            </div>

            <div class="mt-4" style="position: relative; z-index: 10;">
              <time-picker
                v-model="pickupTime"
                label="降園時間"
                prepend-icon="mdi-clock-time-four-outline"
                :rules="[rules.required]"
                variant="outlined"
                density="compact"
                color="primary"
              />
            </div>

            <div class="mt-4">
              <v-textarea
                v-model="pickupReason"
                :rules="[rules.required, rules.counter100]"
                label="理由"
                auto-grow
                max-rows="7"
                variant="outlined"
                density="compact"
                color="primary"
              />
            </div>
          </v-form>
        </v-window-item>
      </v-window>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="close" color="error" variant="text"> キャンセル </v-btn>
      <div style="width: 16px;"></div>
      <v-btn @click="clickPost" :loading="btnLoading" color="primary" variant="flat">
        送信
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import rules from '@/service/ValidRules';
import TimePicker from '@/components/molecules/TimePicker.vue';
import { chatModule } from '@/store/entityModules/chat';

export default defineComponent({
  name: 'PickupModal',
  components: { TimePicker },
  props: {
    isOpen: { type: Boolean, default: false },
    childId: { type: Number, default: NaN },
    selectedDate: { type: String, default: () => dayjs().format('YYYY-MM-DD') },
  },
  emits: ['close', 'posted'],

  data() {
    return {
      tabs: 'dropOff',
      dropOffDate: '',
      dropOffDateVal: null as any,
      pickupDate: '',
      pickupDateVal: null as any,
      dropOffById: null as any,
      dropOffTime: dayjs().format('HH:00'),
      pickupById: null as any,
      pickupTime: dayjs().format('HH:00'),
      dropOffReason: '',
      pickupReason: '',
      fetchLoading: false,
      isDropOffDatePicker: false,
      isPickupDatePicker: false,
      btnLoading: false,
    };
  },

  computed: {
    rules() { return rules; },
    allowMinDate() { return new Date(); },
    parentChoices() { return chatModule.parentChoice; },
  },

  watch: {
    isOpen: {
      async handler(val: boolean) {
        if (val) {
          this.resetForm();
          if (this.parentChoices.length === 0) {
            this.fetchLoading = true;
            try {
              await chatModule.fetchChatsChoices();
            } catch (error) {
              console.error(error);
            } finally {
              this.fetchLoading = false;
            }
          }
        }
      },
      immediate: true,
    },
  },

  methods: {
    resetForm() {
      this.dropOffDate = this.selectedDate;
      this.pickupDate = this.selectedDate;
      this.dropOffDateVal = new Date(this.selectedDate);
      this.pickupDateVal = new Date(this.selectedDate);
      
      this.dropOffById = null;
      this.pickupById = null;
      this.dropOffReason = '';
      this.pickupReason = '';
    },
    onDropOffDateChange(val: any) {
      if (!val) return;
      this.dropOffDate = dayjs(val).format('YYYY-MM-DD');
    },
    onPickupDateChange(val: any) {
      if (!val) return;
      this.pickupDate = dayjs(val).format('YYYY-MM-DD');
    },
    close() {
      this.$emit('close');
    },
    async clickPost() {
      const formRef = this.tabs === 'dropOff' 
        ? (this.$refs.post_dropoff_form as any) 
        : (this.$refs.post_pickup_form as any);
      
      if (!formRef) return;
      
      const { valid } = await formRef.validate();
      if (!valid) return;

      this.btnLoading = true;
      try {
        const isDropOff = this.tabs === 'dropOff';
        const targetDate = isDropOff ? this.dropOffDate : this.pickupDate;
        const targetTimeStr = isDropOff ? this.dropOffTime : this.pickupTime;
        
        const [hour, minute] = targetTimeStr.split(':');
        const isoTime = dayjs(targetDate).hour(Number(hour)).minute(Number(minute)).toISOString();

        await chatModule.putChatsPickup({
          childId: this.childId,
          date: targetDate,
          dropOffById: isDropOff ? this.dropOffById : null,
          dropOffTime: isDropOff ? isoTime : null,
          pickupById: isDropOff ? null : this.pickupById,
          pickupTime: isDropOff ? null : isoTime,
          reason: isDropOff ? this.dropOffReason : this.pickupReason,
        });

        this.$emit('posted');
        this.$emit('close');
      } catch (error) {
        console.error("Post Error:", error);
      } finally {
        this.btnLoading = false;
      }
    },
  },
});
</script>

<style>
/* iOS向けの透明バリアCSS */
.ios-click-barrier {
  cursor: pointer;
  display: block;
  width: 100%;
}
.pointer-events-none {
  pointer-events: none !important;
}
</style>

<style lang="scss" scoped>
/* ダイアログ（カレンダー）がスマホ画面からはみ出さないように制限 */
:deep(.v-overlay__content) {
  max-width: 100% !important;
}
:deep(.v-date-picker) {
  max-width: 100% !important;
  min-width: unset !important;
  height: 100%;
}

:deep(.v-card) {
  display: flex;
  flex-direction: column;
}

/* テキストエリアのリサイズでボトムナビが動くのを防ぐ */
:deep(.v-textarea textarea) {
  resize: none !important;
}

/* 超小型端末（iPhone SE等）への安全策 */
@media (max-width: 360px) {
  :deep(.v-date-picker) {
    transform: scale(0.9);
    transform-origin: center center;
  }
}
/* styleセクションに追加 */
:deep(.v-card-text) {
  /* iOSでの慣性スクロールと座標計算の安定化 */
//  -webkit-overflow-scrolling: touch;
  flex: 1;
  overflow-y: auto;
}

/* メニューの表示位置がずれるのを防ぐ */
:deep(.v-overlay-container) {
//  position: fixed !important;
}
:deep(.v-slide-group__content) {
  overflow: visible;
}
:deep(.v-tabs) {
  min-height: 56px;
}</style>